import { default as join } from './join/routes'
import { default as category } from './category/routes'

export default [
    ...join,
    ...category,
]